// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2372":"e6c6a9caf0f28945","5416":"294a497239f0438e","7957":"100375c5749f0556"}[chunkId] + ".css";
};